let faqTileJS = (function () {
    let initialized = false;

    return {
        Init: function () {
            if (initialized) {
                return;
            }

            $(window).on('resize', function() {
                if(window.innerWidth > 1199.98) {
                    $(".faq-forms-docs-overlay").css('display', '');
                    $(".faq-forms-docs-mobile-button-container").css('display', '');
                    $("html").css("overflow", "");
                    $(".faq-forms-docs-mobile-search-container").css("display", "");
                    $(".faq-tile").css("margin-top", "");
                }
                else {
                    toggleScroll();
                }
            });

            /*User Search*/
            const question = $(".faq-tile-question");
            const answers = $(".faq-tile-answer");
            const topicTitle = $(".faq-tile-topicTitle");
            const userInput = $(".faq-search-field");

            //Filter Through Search
            userInput.keyup(function () {
                const word = this.value;

                //Sync the 2 search fields
                $(".faq-search-field").val(word);

                //Shows/hides topic names
                if (word !== '') {
                    for (let i = 0; i < topicTitle.length; i++) {
                        $(topicTitle[i]).addClass('d-none');
                    }
                } else {
                    for (let i = 0; i < topicTitle.length; i++) {
                        $(topicTitle[i]).removeClass('d-none');
                    }
                }

                //Shows/hides questions and answers
                for (let i = 0; i < question.length; i++) {
                    const questionTitle = question[i];
                    const answer = $(answers[i]).text().toLowerCase();
                    const titleText = question[i].innerText.trim().toLowerCase();

                    if (!titleText.includes(word) && !answer.includes(word)) {
                        questionTitle.classList.add('d-none');
                        $(answers[i]).addClass('d-none');
                        //Hides Read More/Less
                        if(answer.length > 490 || $(answers[i]).data("li-count") > 3) {
                            $(answers[i]).siblings('.faq-tile-read-more').addClass('d-none');
                            $(answers[i]).siblings('.faq-tile-read-less').addClass('d-none');
                        }
                    } else {
                        questionTitle.classList.remove('d-none');
                        $(answers[i]).removeClass('d-none');

                        if(answer.length > 490 || $(answers[i]).data("li-count") > 3) {
                            $(answers[i]).siblings('.faq-tile-read-less').trigger('click');
                        }
                    }
                }
            });

            $('.faq-tile-read-more').click(function() {
                $(this).addClass('d-none');
                $(this).siblings('.faq-tile-read-less').removeClass('d-none');
                $(this).prev().addClass('faq-line-clamp-unset');
            });

            $('.faq-tile-read-less').click(function() {
                $(this).addClass('d-none');
                $(this).siblings('.faq-tile-read-more').removeClass('d-none');
                $(this).prev().prev().removeClass('faq-line-clamp-unset');

            });

            $('.faq-forms-docs-mobile-filter-button').click(function() {
                $(".faq-forms-docs-overlay").css("display", "block");
                $("html").css("overflow", "hidden");
                toggleScroll();
            });

            $('.faq-forms-docs-overlay-close-button').click(function() {
                $(".faq-forms-docs-overlay").css("display", "");
                $("html").css("overflow", "");
            });

            $('.faq-forms-docs-overlay-list-item').click(function() {
                const target = $(this).attr('id');
                $("html").css("overflow", "");
                $('html, body').animate({
                    scrollTop: $('#'+ target).offset().top - 70
                });
                $('.faq-forms-docs-overlay-close-button').trigger('click');
            });

            $('.faq-forms-docs-mobile-search-button').click(function() {
                $(".faq-forms-docs-mobile-button-container").css("display", "none");
                $(".faq-forms-docs-mobile-search-container").css("display", "flex");
                $(".faq-tile").css("margin-top", "80px");

                $(".faq-forms-docs-mobile-search-container").find('.faq-search-field').focus();
            });

            $('.faq-forms-docs-mobile-search-close').click(function() {
                $(".faq-forms-docs-mobile-button-container").css("display", "");
                $(".faq-forms-docs-mobile-search-container").css("display", "");
                $(".faq-tile").css("margin-top", "");
            });

            //If there are too many items, make it scrollable
            function toggleScroll() {
                const list = $('.faq-forms-docs-overlay-list');
                const scrollHeight = list[0].scrollHeight;
                const clientHeight = list[0].clientHeight;

                if(scrollHeight > clientHeight) {
                    list.css("overflow", "auto");
                }
                else {
                    list.css("overflow", "");
                }
            }

            initialized = true;
        }
    }
})();